import Api from "@/services/Api";
import axios from "axios";

const shardedRequest = function({url, params}) {
	const hadsShard    = Api().get(url, { params: { ...params, storechain: "tls-app-hads" } });
	const defaultShard = Api().get(url, { params: { ...params, storechain: "tls-app-default" } });

	return axios.all([hadsShard, defaultShard])
		.then(axios.spread((...responses) => responses.map(response => response.data)))
		.catch(error => Promise.reject(error));
};

export default {
	async all({ scope, groupId, page = 1, limit = 100 } = {}) {
		const	params = { limit: limit, page: page };
		let url      = "/tls/groups/cases";
		
		if (scope) { url += `/${scope}`; }

		groupId ? params["group_id"] = groupId : params["storechain"] = "tls-app-hads";

		return Api().get(url, { params })
			.then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async allSharded({ scope, page = 1, limit = 100 } = {}) {
		const baseUrl      = "/tls/groups/cases";
		const url          = scope ? `${baseUrl}/${scope}` : baseUrl;
		const	params       = { limit: limit, page: page };

		return shardedRequest({ url, params });
	},

	async mineSharded({ _scope, page = 1, limit = 100 } = {}) {
		const baseUrl      = "/tls/groups/cases/mine";
		// const url       = scope ? `${baseUrl}/${scope}` : baseUrl;
		const	params       = { limit: limit, page: page };

		return shardedRequest({ url: baseUrl, params });
	},

	async mine({ groupId, page = 1, limit = 100 } = {}) {
		const	params = { limit: limit, page: page };

		groupId ? params["group_id"] = groupId : params["storechain"] = "tls-app-hads";

		return Api().get("/tls/groups/cases/mine", { params })
			.then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async stats() {
		return Api().get("/tls/groups/cases/stats", {
			params: {
				storechain: "tls-app-hads"
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async find({ groupId, caseId } = {}) {
		const params = Object.assign({}, groupId ? { "group_id": groupId } : { "storechain": "tls-app-hads" });

		return Api().get(`/tls/groups/cases/${caseId}`, { params })
			.then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async assign(caseId, ownerId) {
		const data = new FormData();
		const url = `/tls/groups/cases/${caseId}/assign`;

		data.set("tls_case[owner_id]", ownerId);

		return Api()({
			method: "post",
			url:    url,
			data:   data,
			params: {
				storechain: "tls-app-hads"
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async create({ subject, message, groupId, proId }) {
		const data = new FormData();
		const url = "/tls/groups/cases";

		data.set("tls_case[message]", message);
		data.set("tls_case[subject]", subject);
		data.set("tls_case[group_id]", groupId);
		data.set("tls_case[pro_id]", proId);

		return Api()({
			method: "post",
			url:    url,
			data:   data,
			params: {
				group_id: groupId
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async close({ groupId, caseId }) {
		const data   = new FormData();
		const url    = `/tls/groups/cases/${caseId}`;
		const params = Object.assign({}, groupId ? { "group_id": groupId }: { "storechain": "tls-app-hads" });

		data.set("tls_case[status]", "resolved");

		return Api()({
			method: "put",
			url:    url,
			data:   data,
			params
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},
};
